import { render, staticRenderFns } from "./PresentLevelsGoalRecommendations.vue?vue&type=template&id=60ab1397&scoped=true"
import script from "./PresentLevelsGoalRecommendations.vue?vue&type=script&lang=js"
export * from "./PresentLevelsGoalRecommendations.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsGoalRecommendations.vue?vue&type=style&index=0&id=60ab1397&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab1397",
  null
  
)

export default component.exports